<template>
  <div
    class="mainContent dashboard hor-padding-5 hor-padding-30-ms"
    v-loading="loading"
  >
    <h1 class="ver-padding-20">Аналитика</h1>
    <div class="page-block">
      <div class="filters grid cross-center">
        <div v-if="merchantList.length > 1">
          <el-select
            v-model="request.merchants"
            multiple
            filterable
            clearable
            collapse-tags
            placeholder="Предприятие"
            class="merchant"
            @change="onValueChange"
            size="small"
          >
            <el-option
              v-for="item in merchantList"
              :key="item.id"
              :label="item.human_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div v-if="terminalList.length > 0">
          <el-select
            v-model="request.terminals"
            multiple
            filterable
            clearable
            collapse-tags
            placeholder="Терминал"
            class="terminal"
            @change="onValueChange"
            size="small"
          >
            <el-option
              v-for="item in terminalListSort"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <AppButton
            v-if="!showRefresh"
            size="mini"
            type="green"
            class="r-margin-10"
            @click.prevent="applyFilters"
            >Применить</AppButton
          >
          <AppButton
            v-if="showRefresh"
            size="mini"
            type="blue"
            @click.prevent="refreshData"
            >Обновить</AppButton
          >
        </div>
      </div>
    </div>

    <div class="u-16" style="margin-top: 15px" v-if="!isValidConversion">
      <el-alert
        title="На данный момент суммовые показатели сконвертированы не полностью. Для получения актуальных данных повторите запрос позже"
        type="warning"
        show-icon
      >
      </el-alert>
    </div>

    <analyticsRow
      :analyticsData="analyticsData"
      :type="analyticsData.type"
      :currency="currencyCharacter(curentCurrencyCode)"
    ></analyticsRow>

    <div class="page-block u-16">
      <div class="filters grid" v-if="show">
        <div class="r-margin-20">
          <Calendar :options="rangeCalendar" v-on:vdp-change="dateChange" />
        </div>
        <div class="month-block">
          <el-radio-group
            v-model="radioMonths"
            class="grid"
            @change="changeMonth"
          >
            <el-radio-button
              v-for="month in monthLine"
              :label="month.id"
              :key="month.id"
              class="u"
              >{{ month.name }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <hr class="u-16" />
      </div>
      <div>
        <chart-payment
          :key="showToolbox"
          :chartData="orderList"
          :titleText="chartTitle"
          :showToolbox="showToolbox"
          :collapsed="isCollapsed"
          :request="request"
          :currency="currencyCharacter(curentCurrencyCode)"
          v-on:loadAsyncData="loadAsyncData"
          v-on:clearData="clearData"
        ></chart-payment>
      </div>
    </div>

    <el-collapse-transition>
      <div class="u-16 grid center show-more" v-show="!showFull">
        <button type="text" @click="showMore">Показать всю статистику</button>
      </div>
    </el-collapse-transition>
    <div class="u-16 grid" v-if="showFull">
      <!-- chart banks -->
      <div class="u-16 u-8-ms u-6-xls chart r-padding-0 r-padding-20-xls">
        <div
          class="page-block table-bank u-16"
          v-loading="!loadOption.issuer_bank_names"
        >
          <h4>Банк-эмитент</h4>
          <table-chart
            :chartData="chartEBankData"
            :color="'#4d71ef'"
            :img="false"
            :card="false"
          ></table-chart>
        </div>
      </div>
      <!-- /.chart banks -->

      <!-- .chart states -->
      <div
        class="u-16 u-12-ms u-13-ls u-4-xls chart r-padding-0 r-padding-20-ms"
      >
        <div class="page-block states" v-loading="!loadOption.states">
          <h4>Статусы</h4>
          <table-chart
            :chartData="chartStateData"
            :color="'#4d71ef'"
            :img="false"
            :card="false"
          ></table-chart>
        </div>
      </div>
      <!-- /.chart states -->

      <!-- chart rejection -->
      <div
        class="u-16 u-8-ms u-6-xls chart r-padding-0 r-padding-20-ms r-padding-0-xls"
      >
        <div
          class="page-block table-rejections"
          v-loading="!loadOption.processing_error_codes"
        >
          <h4>Причина отказа</h4>
          <table-chart
            :chartData="chartRejectionsData"
            :color="'#ef6360'"
            :img="false"
            :card="false"
          ></table-chart>
        </div>
      </div>
      <!-- /.chart rejection -->

      <!-- chart 3ds -->
      <div
        class="u-16 u-4-ms u-4-ls chart-3ds chart r-padding-0 r-padding-20-xls"
      >
        <div
          class="page-block"
          v-loading="!loadOption.is_not_3ds && !loadOption.is_3ds"
        >
          <h4 class="padding-20">3DS</h4>
          <chart-pie
            :chartData="chart3DSData"
            :collapsed="isCollapsed"
          ></chart-pie>
        </div>
      </div>
      <!-- /.chart-3ds -->

      <!-- chart region -->
      <div class="u-16 u-8-ms u-6-xls chart r-padding-0 r-padding-20-xls">
        <div class="page-block" v-loading="!loadOption.issuer_country_codes">
          <h4>Страна эмитента (Top-10)</h4>
          <table-chart
            :chartData="chartRegionData"
            :color="'#4d71ef'"
            :img="false"
            :card="false"
          ></table-chart>
        </div>
      </div>
      <!-- /.chart region -->

      <!-- chart active time -->
      <div class="u-16 u-8-ms u-6-xls chart">
        <div class="page-block" v-loading="!loadOption.active_time">
          <h4>Активные часы</h4>
          <chart-active :chartData="chartActiveData"></chart-active>
        </div>
      </div>
      <!-- ./ chart active time -->

      <!-- chart processing -->
      <div class="u-16 u-8-ms u-6-xls chart r-padding-0 r-padding-20-ms">
        <div
          class="page-block table-processing"
          v-loading="!loadOption.processings"
        >
          <h4>Процессинг</h4>
          <table-chart
            :chartData="chartProcessingsData"
            :color="'#4d71ef'"
            :img="true"
            :card="false"
          ></table-chart>
        </div>
      </div>
      <!-- /.chart processing -->

      <!-- chart product type -->
      <div class="u-16 u-6-xls chart r-padding-0 r-padding-20-ms">
        <div
          class="page-block table-ps"
          v-loading="!loadOption.issuer_card_product_types"
        >
          <h4>Тип продукта</h4>
          <table-chart
            :chartData="chartProductType"
            :color="'#4d71ef'"
            :img="false"
            :card="false"
          ></table-chart>
        </div>
      </div>

      <!-- chart payment system -->
      <div class="u-16 u-4-xls chart">
        <div
          class="page-block table-ps grid"
          v-loading="!loadOption.issuer_payment_systems"
        >
          <h4 class="u-16">Платежная система</h4>
          <chart-scatter :chartData="chartPSData"></chart-scatter>
          <!-- <table-chart :chartData="chartPSData" :color="'#13CE66'" :img="false" :card="true"></table-chart> -->
        </div>
      </div>
      <!-- /.chart payment system -->
    </div>
  </div>
</template>

<script>
const monthsOptions = [
  { id: 0, name: "Январь" },
  { id: 1, name: "Февраль" },
  { id: 2, name: "Март" },
  { id: 3, name: "Апрель" },
  { id: 4, name: "Май" },
  { id: 5, name: "Июнь" },
  { id: 6, name: "Июль" },
  { id: 7, name: "Август" },
  { id: 8, name: "Сентябрь" },
  { id: 9, name: "Октябрь" },
  { id: 10, name: "Ноябрь" },
  { id: 11, name: "Декабрь" },
];

import Vue from "vue";
import Vuex from "vuex";
import store from "../store";

import { apiUrl } from "@/api/apiUrl";

import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import { _ } from "underscore";
import VCharts from "v-charts";
import VueAnimateNumber from "vue-animate-number";
import Calendar from "@/components/calendar/calendar";

import analyticsRow from "@/components/dashboard/analyticsRow.vue";

// charts components
import chartPayment from "@/components/charts/chartPayments";
import chartPie from "@/components/charts/chartPie";
import chartScatter from "@/components/charts/chartScatter";
import chartActive from "@/components/charts/chartActive";
import tableChart from "@/components/charts/tableChart";

import error_code from "@/chartSettings/errorCode.js";
import currency from "../store/modules/currency";
Vue.use(VCharts);
Vue.use(VueAnimateNumber);

export default {
  name: "Dashboard",
  data() {
    return {
      loading: true,
      loadingBlock: false,
      show: true,
      showFull: false,
      showRefresh: false,
      months: monthsOptions,
      radioMonths: [],
      orderList: {
        columns: [
          "timestamp",
          "successful_amount",
          "fail_amount",
          "conversion",
          "successful_total",
          "fail_total",
        ],
        rows: [],
      },
      curentCurrencyCode: null,
      isValidConversion: true,
      total: 0,
      dataEmpty: true,
      request: {
        merchants: [],
        terminals: [],
        date_range: [],
        period: "daily",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "Сегодня",
            onClick(picker) {
              let end = moment()
                .millisecond(0)
                .second(59)
                .minute(59)
                .hour(23)
                .toDate();
              let start = moment()
                .millisecond(0)
                .second(0)
                .minute(0)
                .hour(0)
                .toDate();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Вчера",
            onClick(picker) {
              let start = moment()
                .add(-1, "days")
                .millisecond(0)
                .second(0)
                .minute(0)
                .hour(0)
                .toDate();
              let end = moment()
                .add(-1, "days")
                .millisecond(0)
                .second(59)
                .minute(59)
                .hour(23)
                .toDate();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Неделя",
            onClick(picker) {
              let end = moment()
                .millisecond(0)
                .second(59)
                .minute(59)
                .hour(23)
                .toDate();
              let start = moment()
                .add(-1, "weeks")
                .millisecond(0)
                .second(0)
                .minute(0)
                .hour(0)
                .toDate();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Месяц",
            onClick(picker) {
              let end = moment()
                .millisecond(0)
                .second(59)
                .minute(59)
                .hour(23)
                .toDate();
              let start = moment()
                .add(-1, "months")
                .millisecond(0)
                .second(0)
                .minute(0)
                .hour(0)
                .toDate();
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      rangeCalendar: {
        type: "rangedate",
        locale: "ru",
        startDate: moment().startOf("month"),
        endDate: moment(),
        maxDate: moment().add(0, "day"),
        format: "DD.MM.YYYY",
      },
      chartTitle: {},
      showToolbox: false,
      toConversion: 0,
      conversion: 0,
      successCount: 0,
      successAmount: 0,
      failCount: 0,
      failAmount: 0,
      chartStateData: {
        columns: ["state_id", "count"],
        rows: [],
      },
      chartRejectionsData: {
        columns: ["code", "count"],
        rows: [],
      },
      chartProcessingsData: {
        columns: ["code", "count"],
        rows: [],
      },
      chartEBankData: {
        columns: ["code", "count"],
        rows: [],
      },
      chartRegionData: {
        columns: ["code", "count"],
        rows: [],
      },
      chartRegionDataOther: {
        columns: ["code", "count"],
        rows: [],
      },
      chartIPData: {
        columns: ["code", "count"],
        rows: [],
      },
      chartIPDataOther: {
        columns: ["code", "count"],
        rows: [],
      },
      chartPSData: {
        columns: ["code", "count"],
        rows: [],
      },
      chart3DSData: {
        columns: ["code", "count"],
        rows: [
          { code: "is_3ds", count: 0 },
          { code: "is_not_3ds", count: 0 },
        ],
      },
      chartProductType: {
        columns: ["code", "count"],
        rows: [],
      },
      chartActiveData: {},
      loadIndex: 0,
      loadOption: {
        trigger: false,
        states: false,
        processing_error_codes: false,
        processings: false,
        issuer_country_codes: false,
        issuer_bank_names: false,
        issuer_payment_systems: false,
        ip_country_codes: false,
        is_3ds: false,
        is_not_3ds: false,
        active_time: false,
        issuer_card_product_types: false,
      },
      colors: [],
      analyticsData: {
        type: "",
        list: [],
      },
    };
  },
  methods: {
    applyFilters() {
      if (!this.loading) {
        let req = {};
        for (const prop in this.request) {
          if (this.request.hasOwnProperty(prop)) {
            req[prop] = this.request[prop];
          }
        }
        req = _.pick(req, (val) => val.length > 0 || val == true);
        this.loadAsyncData(req);
      } else return false;
    },

    refreshData() {
      this.clearData();
      this.applyFilters();
    },

    loadAsyncData(params, cdata) {
      var paramRequest;
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token"),
        },
      };
      this.loading = true;
      if (!_.isEmpty(params)) {
        paramRequest = Object.assign({}, this.defParam, params);
      } else {
        paramRequest = Object.assign({}, this.defParam);
      }

      if (cdata) {
        paramRequest = Object.assign(paramRequest, { expect: [cdata] });
        if (cdata == "active_time")
          paramRequest = _.extend(paramRequest, { period: "3hours" });
        this.loading = false;
        this.loadingBlock = true;
      } else {
        this.total = 0;
        this.conversion = 0;
        this.successAmount = 0;
        this.successCount = 0;
        this.failAmount = 0;
        this.failCount = 0;
      }

      if (this.isSidebarOpened) {
        setTimeout(() => {
          store.commit("hideSidebar");
        }, 500);
      }

      this.dataEmpty = true;
      axios
        .post(apiUrl + "analytics/stats", paramRequest, config)
        .then(({ data }) => {
          if (!cdata) {
            this.analyticsData.type = "general";
            this.analyticsData.list = [];

            this.analyticsData.list.push({
              name: "success",
              width: data.conversion,
              amount: data.successful_amount,
              total: data.successful_total,
            });

            this.analyticsData.list.push({
              name: "fail",
              width:
                (data.conversion >= 0 || data.successful_total == 0) &&
                data.fail_total > 0
                  ? 1 - data.conversion
                  : 0,
              amount: data.fail_amount,
              total: data.fail_total,
            });

            this.total = data.total;
            this.curentCurrencyCode = data.currency_code;
            this.isValidConversion = data.is_valid_conversion;
            this.conversion = (data.conversion * 100).toFixed(2);
            this.successAmount = data.successful_amount;
            this.successCount = data.successful_total;
            this.failAmount = data.fail_amount;
            this.failCount = data.fail_total;
            this.chartTitle = this.textTitle(this.request.date_range);
            this.orderList.rows = this.dataOrder(data.data);
            this.showToolbox = paramRequest.period == "hourly";
          } else {
            if (cdata == "states")
              this.chartStateData.rows = this.dataStates(data.data);
            if (cdata == "processing_error_codes")
              this.chartRejectionsData.rows = this.dataBar(data.data, cdata);
            if (cdata == "processings")
              this.chartProcessingsData.rows = this.dataBar(data.data, cdata);
            if (cdata == "issuer_country_codes") {
              let regionData = this.dataBar(data.data, cdata);
              this.chartRegionData.rows = regionData;
              this.chartRegionDataOther.rows =
                regionData.length > 10
                  ? regionData.slice(10, regionData.length)
                  : regionData;
            }
            if (cdata == "issuer_bank_names")
              this.chartEBankData.rows = this.dataBar(data.data, cdata);
            if (cdata == "ip_country_codes") {
              let ipData = this.dataBar(data.data, "ip_country_codes");
              this.chartIPData.rows = ipData;
              this.chartIPDataOther.rows =
                ipData.length > 2 ? ipData.splice(2, ipData.length) : ipData;
            }
            if (cdata == "issuer_payment_systems")
              this.chartPSData.rows = this.dataBar(data.data, cdata);

            if (cdata == "is_3ds") {
              this.chart3DSData.rows[0].count = this.data3ds(data.data, cdata);
            }

            if (cdata == "is_not_3ds") {
              this.chart3DSData.rows[1].count = this.datanon3ds(
                data.data,
                cdata
              );
            }

            if (cdata == "issuer_card_product_types") {
              this.chartProductType.rows = this.dataBar(data.data, cdata);
            }
            if (cdata == "active_time")
              this.chartActiveData = { ...data.active_time };
          }

          this.dataEmpty = false;
          this.loading = false;
          this.resizeElements();
        })
        .then(() => {
          this.loading = false;
          this.loadingBlock = false;
          this.showRefresh = true;
          if (cdata) this.loadOption[cdata] = true;
        })
        .catch((error) => {
          this.dataEmpty = true;
          this.loading = false;
          throw error;
        });
    },
    dataOrder(data) {
      let tempData = data ? data : [];
      tempData = tempData.map((el) => {
        // el.fail_amount = el.fail_amount * -1;
        el.conversion = el.conversion * 100;
        return _.pick(
          el,
          "conversion",
          "successful_amount",
          "fail_amount",
          "successful_total",
          "fail_total",
          "timestamp"
        );
      });
      return tempData.reverse();
    },
    data3ds(data, cdata) {
      let total3ds = 0;
      data.forEach((el) => {
        if (cdata == "is_3ds") {
          total3ds = total3ds + el[cdata];
        }
      });
      return total3ds;
    },
    datanon3ds(data, cdata) {
      let totalnon3ds = 0;
      data.forEach((el) => {
        if (cdata == "is_not_3ds") {
          totalnon3ds = totalnon3ds + el[cdata];
        }
      });
      return totalnon3ds;
    },
    dataBar(data, param) {
      let obj = {};
      let arr = [];
      if (data) {
        data.forEach((el) => {
          if (el[param] != null) {
            for (const prop in el[param]) {
              if (!obj.hasOwnProperty(prop)) {
                obj[prop] = el[param][prop];
              } else {
                obj[prop] = obj[prop] + el[param][prop];
              }
            }
          }
        });
      }
      obj = _.omit(obj, "NONE");
      let keys = Object.keys(obj);
      let totalValue = keys.reduce((total, k) => total + obj[k], 0);
      keys.forEach((item) => {
        let o = {};
        if (obj.hasOwnProperty(item)) {
          if (param == "processings") {
            o["code"] = this.processingName(item);
          } else if (
            param == "issuer_country_codes" ||
            param == "ip_country_codes"
          ) {
            o["code"] = this.countryNameRu(item);
          } else if (param == "issuer_payment_systems") {
            o["code"] = this.cardName(item);
          } else {
            o["code"] = item;
          }
          o["count"] = obj[item];
          o["percent"] = ((obj[item] / totalValue) * 100).toFixed(2);
          o["id"] = item;
          arr.push(o);
        }
      });
      arr.sort((a, b) => b.count - a.count);
      let index;
      arr.forEach((el, i) => {
        if (el.code == "") index = i;
      });
      if (index !== -1 && typeof index != "undefined") arr.splice(index, 1);

      if (param == "issuer_bank_names") arr = arr.slice(0, 10);
      if (
        arr.length < 10 &&
        param != "issuer_country_codes" &&
        param != "ip_country_codes" &&
        param != "issuer_payment_systems"
      ) {
        let remain = 7 - arr.length;
        for (let t = 0; t < remain; t++) {
          arr.push({ code: "", count: null });
        }
      }
      return arr;
    },
    dataStates(data) {
      const states = [-1, 0, 1, 3, 4, 6, 8, 10, 12, 14, 16, 18, 20];
      const colors_state = [
        "#FF626C",
        "#bbbbbb",
        "#C7C128",
        "#DEAB3E",
        "#607D8B",
        "#795548",
        "#24CF7E",
        "#039BE5",
        "#dddddd",
        "#B388FF",
        "#7C4DFF",
        "#32ADB1",
        "#21C6D2",
      ];
      let colors = [];
      let obj = {};
      let st = {};
      let arr = [];
      data.forEach((el) => {
        if (el.states != null) {
          for (const prop in el.states) {
            if (!obj.hasOwnProperty(prop)) {
              obj[prop] = el.states[prop];
            } else {
              obj[prop] = obj[prop] + el.states[prop];
            }
          }
        }
      });
      states.forEach((state, index) => {
        let o = {};
        if (obj.hasOwnProperty(state)) {
          o["state_id"] = this.statusName(state);
          o["count"] = obj[state];
          o["color"] = colors_state[index];
          arr.push(o);
        }
      });
      arr.sort((a, b) => b.count - a.count);
      arr.forEach((el) => colors.push(el.color));
      this.colors = colors;
      return arr;
    },
    formatter: function (num) {
      return num.toFixed(2);
    },
    formatterSumm: function (num) {
      num = (num / 100).toFixed(2);
      return num.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
    },
    totalFormat(num) {
      return num
        .toFixed(0)
        .toString()
        .replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
    },
    changeMonth(e) {
      var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth(),
        d = date.getDate();
      y = m < e ? y - 1 : y;
      let start = new Date(y, e, 1, 0, 0, 0, 0);
      let end =
        m != e
          ? new Date(y, e + 1, 0, 23, 59, 59, 0)
          : new Date(y, e, d, 23, 59, 59, 0);

      this.rangeCalendar["startDate"] = moment(start);
      this.rangeCalendar["endDate"] = moment(end);

      this.request.date_range = [
        moment(start).format("YYYY-MM-DDTHH:mm:ss.000000"),
        moment(end).format("YYYY-MM-DDTHH:mm:ss.000000"),
      ];

      this.request.period = "daily";

      this.loadAsyncData(this.request);
      this.clearData();
    },
    dateChange(value) {
      this.radioMonths = null;
      this.request.period = "daily";
      let start = moment(value.startDate).format("YYYY-MM-DDTHH:mm:ss.000000");
      let end = moment(value.endDate).format("YYYY-MM-DDTHH:mm:ss.000000");
      this.request.date_range = [start, end];
      if (value.trigger && value.trigger == "end") {
        this.onValueChange([start, end]);
        this.loadAsyncData(this.request);
      }
    },
    onValueChange(e) {
      if (e.length == 0) this.request.terminals = [];
      let req = {};
      for (const prop in this.request) {
        if (this.request.hasOwnProperty(prop)) {
          req[prop] = this.request[prop];
        }
      }
      req = _.pick(req, (val) => val.length > 0);
      this.saveFilters();
      //this.loadAsyncData(req);
      this.clearData();
    },
    defaultData() {
      var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth(),
        d = date.getUTCDate();
      let start = new Date(y, m, 1, 0, 0, 0, 0);
      let end = new Date(y, m, d, 23, 59, 59, 0);
      this.request.date_range = [
        moment(start).format("YYYY-MM-DDTHH:mm:ss.000000"),
        moment(end).format("YYYY-MM-DDTHH:mm:ss.000000"),
      ];
    },
    textTitle(value) {
      let date_range = value.map((el) => {
        let date = moment(el),
          d = date.format("DD").toString(),
          m = date.format("MM").toString(),
          y = date.format("YY").toString();
        // if (d.length < 2) d = "0" + d;
        // if (m.length < 2) m = "0" + m;
        return d + "." + m + "." + y;
      });
      let title = {
        text: "Отчет за " + date_range.join(" - "),
        subtext:
          this.successCount +
          " успешных платежей на сумму " +
          this.formatterSumm(this.successAmount) +
          " " +
          this.currencyCharacter(this.curentCurrencyCode),
        left: "center",
        textStyle: {
          align: "center",
          fontSize: 16,
          fontWeight: "400",
        },
        subtextStyle: {
          fontSize: 15,
          fontWeight: "300",
          fontFamily: "Roboto, sans-serif",
          color: "#999",
        },
      };
      return title;
    },
    clearData() {
      this.showFull = false;
      this.loadIndex = 0;
      this.chartStateData.rows = [];
      this.chartRejectionsData.rows = [];
      this.chartProcessingsData.rows = [];
      this.chartEBankData.rows = [];
      this.chartRegionData.rows = [];
      this.chartRegionDataOther.rows = [];
      this.chartIPData.rows = [];
      this.chartIPDataOther.rows = [];
      this.chartPSData.rows = [];
      this.chartProductType.rows = [];
      this.chartActiveData = {};

      for (let k in this.loadOption) {
        this.loadOption[k] = false;
      }
    },
    showMore() {
      this.showFull = !this.showFull;
      setTimeout(() => {
        this.resizeText(".resize", 36, 5);
        window.scrollTo({
          top: 800,
          behavior: "smooth",
        });
      }, 500);
      this.loadOption.trigger = true;
    },
    loadOtherCharts(index) {
      let type = [
        "states",
        "processing_error_codes",
        "processings",
        "issuer_country_codes",
        "issuer_bank_names",
        "issuer_payment_systems",
        "ip_country_codes",
        "is_3ds",
        "is_not_3ds",
        "issuer_card_product_types",
        "active_time",
      ];
      if (type[index] != undefined)
        this.loadAsyncData(this.request, type[index]);
    },
    resizeElements() {
      this.resizeText(".resize", 36, 5);
    },
    resizeText(classname, size, factor) {
      let elements = document.querySelectorAll(classname);
      elements.forEach((el) => {
        let w = el.offsetWidth;
        let fz = ((w / factor) | 0) > size ? size : (w / factor) | 0;
        el.style.fontSize = fz + "px";
      });
    },
    saveFilters() {
      let arrMerchants = this.request.merchants,
        arrTerminals = this.request.terminals,
        now = new Date();
      if (arrMerchants.length > 0 || arrTerminals.length > 0) {
        localStorage.setItem("Date_dashboard", now.getTime());
        localStorage.setItem("dashboard_filters", JSON.stringify(this.request));
      } else {
        localStorage.removeItem("Date_dashboard");
        localStorage.removeItem("dashboard_filters");
      }
    },
  },
  beforeMount() {},
  mounted() {
    this.defaultData();
    if (localStorage.getItem("dashboard_filters")) {
      try {
        this.request = JSON.parse(localStorage.getItem("dashboard_filters"));
      } catch (e) {
        localStorage.removeItem("dashboard_filters");
      }
    }
    this.loadAsyncData(this.request);
    this.$nextTick(function () {
      window.addEventListener("resize", this.resizeElements);
    });
    this.resizeText(".resize", 36, 5);
  },
  created() {
    this.$store.dispatch("getProcessing");
    this.$store.dispatch("getTerminal");
    this.$store.dispatch("getMerchant");
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeElements);
  },
  watch: {
    isCollapsed(v) {
      setTimeout(() => {
        this.resizeElements();
      }, 300);
    },
    request: {
      handler: function (newvalue, oldvalue) {
        this.showRefresh =
          newvalue.terminals != oldvalue.terminals &&
          newvalue.merchants != oldvalue.merchants;
      },
      deep: true,
    },
    loadOption: {
      handler: function (v, oldval) {
        if (this.showFull) {
          this.loadOtherCharts(this.loadIndex);
          this.loadIndex++;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "merchantList",
      "merchantName",
      "terminalList",
      "terminalName",
      "processingList",
      "processingName",
      "processingIcon",
      "statusList",
      "statusName",
      "currencyCharacter",
      "countryNameEn",
      "countryNameRu",
      "cardName",
      "isSidebarOpened",
      "isCollapsed",
    ]),
    defaultMonths() {
      let start = moment().add(-1, "month").date(1).format("YYYY-MM-DD");
      let end = moment().date(1).format("YYYY-MM-DD");
      return [start, end];
    },
    monthLine() {
      let d = new Date(),
        m = d.getMonth(),
        arr = [];
      for (let i = 0; i < 12; i++) {
        m = m + 1;
        if (m > 11) m = 0;
        arr[i] = this.months.find((el) => el.id == m);
      }
      return arr;
    },
    terminalListSort() {
      let merchants = this.request.merchants;
      if (typeof merchants != "undefined") {
        if (merchants.length == 0) {
          return this.terminalList;
        } else {
          let terminals = [];
          merchants.forEach((el) => {
            if (typeof this.terminalList != "undefined") {
              let filtered = this.terminalList.filter(
                (item) => item.merchant_id === el
              );
              terminals = terminals.concat(filtered);
            }
          });
          return terminals;
        }
      }
      return this.terminalList;
    },
    blockWidth() {
      if (this.conversion) {
        return this.conversion == 0 ? 50 : this.conversion;
      }
    },
  },
  components: {
    analyticsRow,
    chartPayment,
    chartPie,
    tableChart,
    chartScatter,
    chartActive,
    Calendar,
  },
};
</script>

<style lang="sass">
@import '../assets/style/dashboard.sass'
</style>
